import React, { useRef } from 'react';

import { trackPageJobsChange } from '@xingternal/pages-tracking';
import { Carousel } from '@xingternal/pages-common';

import JobsCard from './JobsCard';

import styles from './Jobs.css';
import { JobCard } from '../types';

type JobsProps = {
  jobs: JobCard[];
};

type CarouselPageChangeType = {
  direction: string;
  page: number;
  total: number;
};

const Jobs: React.FC<JobsProps> = ({ jobs }) => {
  const firstRender = useRef(true);

  const handlePageChange = (pageChange: CarouselPageChangeType) => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      trackPageJobsChange(pageChange);
    }
  };

  return (
    <div data-testid={'jobsContainer'} className={styles.wrapper}>
      <Carousel
        skin={{ carousel: styles.carousel, carouselMain: styles.carouselMain }}
        onPageChange={handlePageChange}
      >
        {jobs.map((job) => (
          <JobsCard job={job} key={job.id} />
        ))}
      </Carousel>
    </div>
  );
};

export default Jobs;
